function filter_extra() {
  const $input = $('.product-facet__filter-item .checkbox-container input[data-value="In stock"]');
  const $container = $('.filter_extra .checkbox-container[data-value="In stock"]');
  
  if ($input.is(':checked')) {
    $container.addClass('active');
  } else {
    $container.removeClass('active');
  }
}


$(document).ready(function () {
  $(document).on('dataLoaded', function () {
    filter_extra();
  });

  setTimeout(function () {
    $(document).trigger('dataLoaded'); 
  }, 1000);
});


$(document).ready(function() {
  var mySwiper = new Swiper ('.swiper-container', {
    slidesPerView: 15,
    paginationClickable: true,
    freeMode: true,
    scrollbar: '.swiper-scrollbar',
    breakpoints: {
      1200: {
        slidesPerView: 10,
      },
      999: {
        slidesPerView: 7,
      },
      740: {
        slidesPerView: 5,
      },
      540: {
        slidesPerView: 4,
      }
    }
  });
    $('.color-item').on('mouseenter', function() {
        var $this = $(this);
        var $colorImgBox = $this.find('.color-img-box');
        var $colorListBox = $this.find('.color-list-box');
        var $img = $colorImgBox.find('span');

        $colorListBox.show();
        $this.addClass('color-list-active');

        $('.color-item').not($this).find('.color-img-box span').css({ width: '50px', height: '50px' });
        $img.css({ width: '60px', height: '60px' });

        var $prevItem = $this.prev('.color-item');
        var $nextItem = $this.next('.color-item');
        
        if ($prevItem.length) $prevItem.find('.color-img-box span').css({ width: '55px', height: '55px' });
        if ($nextItem.length) $nextItem.find('.color-img-box span').css({ width: '55px', height: '55px' });

        if ($this.is(':first-child')) $colorListBox.css({ left: '0', right: 'auto', transform: 'translateX(0)' });
        else if ($this.is(':last-child')) $colorListBox.css({ left: 'auto', right: '0', transform: 'translateX(0)' });
        else $colorListBox.css({ left: '50%', transform: 'translateX(-50%)' });
    });

    $('.color-item').on('mouseleave', function() {
        var $this = $(this);
        var $colorImgBox = $this.find('.color-img-box');
        var $colorListBox = $this.find('.color-list-box');
        var $img = $colorImgBox.find('span');

        $colorListBox.hide();
        $this.removeClass('color-list-active');

        $img.css({ width: '50px', height: '50px' });

        var $prevItem = $this.prev('.color-item');
        var $nextItem = $this.next('.color-item');
        
        if ($prevItem.length) $prevItem.find('.color-img-box span').css({ width: '50px', height: '50px' });
        if ($nextItem.length) $nextItem.find('.color-img-box span').css({ width: '50px', height: '50px' });
    });
        
});

// function color_mouseleave_filter() {
//   $('.color-list-item').on('click', function() {
//     $(this).closest('.color-item').trigger('mouseleave');
//   });
// }


function getUrlParameters(param) {
  var pageUrl = window.location.search.substring(1); 
  var urlVars = pageUrl.split('&');
  var values = [];

  for (var i = 0; i < urlVars.length; i++) {
    var paramNameValue = urlVars[i].split('=');
    if (paramNameValue[0] === param) {
      values.push(decodeURIComponent(paramNameValue[1].replace(/\+/g, ' ')));
    }
  }
  
  return values;
}

function bindColorSwatchClick() {
  var colorValues = getUrlParameters('filter.v.option.color');

  console.log(colorValues);

  setTimeout(function(){
    colorValues.forEach(function(colorValue) {
      $(".product-item-meta__swatch-list").find('div.color-swatch[data-colortip="'+colorValue+'"]').each(function() {
        $(this).click();
      });
    });
  }, 10);
}

$(document).ready(function() {
  bindColorSwatchClick();
});

